import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import { Typography } from "@mui/material";
import { type FC } from "react";

import { RELEVANCE_LABEL_COLOR } from "~/feature/news/constants";
import type { INewsArticle } from "~/types/newsArticle";
import { timeAgo } from "~/utils/timeAgo";

import * as Styled from "./NewsCard.styles";

interface INewsCardProps {
  article: INewsArticle;
}

export const NewsCard: FC<INewsCardProps> = ({ article }) => {
  return (
    <Styled.Root href={article.url} target="_blank" rel="noopener noreferrer">
      <Styled.Thumb>
        {article.imageUrl ? (
          <Styled.ThumbImage
            src={article.imageUrl}
            alt="article"
            loading="lazy"
          />
        ) : (
          <Styled.ThumbPlaceholder>
            <ArticleOutlinedIcon fontSize="small" />
          </Styled.ThumbPlaceholder>
        )}

        {article.relevanceLabel && (
          <Styled.RelevanceChip
            size="small"
            label={article.relevanceLabel}
            color={RELEVANCE_LABEL_COLOR[article.relevanceLabel]}
            data-skip-custom-styles="true"
          />
        )}
      </Styled.Thumb>

      <Styled.Body>
        <Styled.Title component="h3" variant="caption" sx={{ fontWeight: 700 }}>
          {article.title}
        </Styled.Title>

        <Styled.Footer
          direction="row"
          sx={{
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
          }}
        >
          <Styled.Source
            direction="row"
            sx={{ alignItems: "center", gap: 0.5 }}
          >
            {article.sourceLogoUrl && (
              <Styled.SourceLogo
                src={article.sourceLogoUrl}
                alt="source logo"
                loading="lazy"
              />
            )}

            <Typography variant="caption" noWrap sx={{
              color: "text.secondary"
            }}>
              {article.sourceName}
            </Typography>
          </Styled.Source>

          <Typography
            variant="caption"
            suppressHydrationWarning
            sx={{
              color: "text.secondary",
              flexShrink: 0,
              whiteSpace: "nowrap"
            }}>
            {timeAgo(article.publishedAt)}
          </Typography>
        </Styled.Footer>
      </Styled.Body>
    </Styled.Root>
  );
};
